import { withViewModel } from '../../../../../../infrastructure/components/with-view-model';
import {CustomCssFormVM} from './custom-css-form.viewmodel';
import {CustomCssFormPresentation} from './custom-css-form.presentation';

interface IProps {
    vm: CustomCssFormVM;
}

const CustomCssFormContainer = withViewModel(
    CustomCssFormPresentation,
    (props: IProps) => {
        return props.vm;
    },
    () => []
);

export { CustomCssFormContainer as CustomCssForm };
